<template>
  <div class="pane content-tree" :class="treeWrap" ref="box1" id="box1">
    <div class="ly-list tree-view">
      <div class="ly-list-top">
        <div class="ly-title">
          <h3 v-if="!isToggle1" class="title-sub">메세지 템플릿 유형</h3>
          <el-button class="btn-toggle" @click="onTreeView()">
            <i v-if="isToggle1" class="el-icon-arrow-right"></i>
            <i v-else class="el-icon-arrow-left"></i>
          </el-button>
        </div>
        <div v-if="!isToggle1" class="ly-filter">
          <idc-search-catalog
            @filterServiceCatalogKeyword="getFilterKeyword"
          />
          <div class="ly-sort">
            <div class="sort">
              <el-button
                type="primary"
                size="small"
                @click="openMsgSendPopup"
                v-if="!popup"
                >단건발송
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="ly-list-content scrollY-auto" v-show="!isToggle1">
        <idc-tree
          :show-checkbox="false"
          :treeList="!popup?treeList:popTreeList"
          :reg="!popup?'tmp':''"
          @node-click="nodeClick"
          @tmpRegist="tmpRegist"
          @tmpModify="tmpModify"
          ref="tree"
        />
      </div>
    </div>
    <idc-modal
      :visible.sync="dialogAddList"
      title="메세지 발송 리스트 추가"
      width="850px"
    >
      <template #content>
        <msg-add-send-list
          @openOrgModal="dialogOrgChart = true"
          ref="msgAddSend"
        />
      </template>
    </idc-modal>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";
import IdcTree from "@/components/common/IdcTree";
import IdcModal from "@/components/common/IdcModal.vue";
import MsgAddSendList from "@/components/supportmgsysComponents/modal/MsgAddSendList.vue";

export default {
  mixins: [commonMixin],
  components: {
    IdcSearchCatalog,
    IdcTree,
    IdcModal,
    MsgAddSendList,
  },
  created() {
    if (!this.popup) {
      this.$store.dispatch('tempManageStore/getTemplCdList', this.tempType);
    }
  },
  computed: {
    treeList() {
      const root = {id:3280, label: "메세지템플릿분류", menuBtn: false, children: []};
      let list = this.$store.getters['tempManageStore/getTemplCdList'];
      list = this.setElTreeKeyData(list, "cd", "upCd", "cdHnglNm");
      this.setTreeList(root, list);
      return [root];
    },
    popTreeList() {
      const root = {id:3280, label: "메세지템플릿분류", menuBtn: false, children: []};
      let list = this.$store.getters['tempManageStore/getTemplCdList'];
      list = this.setElTreeKeyData(list, "cd", "upCd", "cdHnglNm");
      this.setTreeList(root, list);
      // TODO 타입 체크
      // id:3281 - 메일
      // id:3282 - SMS
      if (this.tempType === 'e-mail') {
        root.children = root.children.filter(node=>node.id===3281);
      } else {
        root.children = root.children.filter(node=>node.id===3282);
      }
      return [root];
    }
  },
  props: {
    popup: {
      type:Boolean,
      default: false
    },
    tempType: {
      type: String,
      default: 'all'
    },
  },
  watch: {
    tempType() {
      // this.$store.dispatch('tempManageStore/getTemplCdList', this.tempType);
    }
  },
  data() {
    return {
      dialogAddList: false
    }
  },
  methods: {
    nodeClick(templCd) {
      if (!this.popup) {
        this.$store.commit('tempManageStore/setCurrentTmplCd', templCd.data || {});
      } else {
        this.$store.commit('tempManageStore/setPopCurrentTmplCd', templCd.data || {});
      }
    },
    tmpRegist(cd) {
      this.$store.commit('tempManageStore/setCurrentCd', {
        upCd: cd.id,
        cdHnglNm: '',
        cdEngNm: '',
        useYn: 'Y',
        delYn: 'N',
      });
      this.$store.commit('popupManageStore/setModalTemplCd', true);
    },
    tmpModify(cd) {
      this.$store.commit('tempManageStore/setCurrentCd', cd.data);
      this.$store.commit('popupManageStore/setModalTemplCd', true);
    },
    getFilterKeyword(keyword) {
      this.$refs.tree.$refs.tree.filter(keyword);
    },
    openMsgSendPopup() {
      this.dialogAddList = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.ly-sort {
  justify-content: flex-end;
}
</style>